/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Iframe_Remote_Style_Guide_Updated_ToastInputs */

const en_iframe_remote_style_guide_updated_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Style guide "${i?.name}" updated successfully`)
};

const fr_iframe_remote_style_guide_updated_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guide de style "${i?.name}" mis a jour avec succes`)
};

const de_iframe_remote_style_guide_updated_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Styleguide "${i?.name}" erfolgreich aktualisiert`)
};

const it_iframe_remote_style_guide_updated_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guida di stile "${i?.name}" aggiornata con successo`)
};

const ru_iframe_remote_style_guide_updated_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Руководство по стилю "${i?.name}" успешно обновлено`)
};

const es_iframe_remote_style_guide_updated_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La guía de estilo "${i?.name}" se actualizó correctamente`)
};

const zh_cn2_iframe_remote_style_guide_updated_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`样式指南“${i?.name}”已成功更新`)
};

const ja_iframe_remote_style_guide_updated_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`スタイルガイド「${i?.name}」が正常に更新されました`)
};

const hi_iframe_remote_style_guide_updated_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्टाइल गाइड "${i?.name}" सफलतापूर्वक अपडेट हो गई`)
};

const pt_pt2_iframe_remote_style_guide_updated_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guia de estilo "${i?.name}" atualizado com sucesso`)
};

/**
* | output |
* | --- |
* | "Style guide \"{name}\" updated successfully" |
*
* @param {Iframe_Remote_Style_Guide_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guide_updated_toast = /** @type {((inputs: Iframe_Remote_Style_Guide_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guide_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_style_guide_updated_toast(inputs)
	if (locale === "de") return de_iframe_remote_style_guide_updated_toast(inputs)
	if (locale === "it") return it_iframe_remote_style_guide_updated_toast(inputs)
	if (locale === "ru") return ru_iframe_remote_style_guide_updated_toast(inputs)
	if (locale === "es") return es_iframe_remote_style_guide_updated_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_style_guide_updated_toast(inputs)
	if (locale === "ja") return ja_iframe_remote_style_guide_updated_toast(inputs)
	if (locale === "hi") return hi_iframe_remote_style_guide_updated_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_style_guide_updated_toast(inputs)
	return en_iframe_remote_style_guide_updated_toast(inputs)
});